'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import BlogCtaClient from '@/components/blog/blog-cta-client'

/* ====== Constants ====== */

const WHATSAPP_NUMBER = '5561999969213'
const FUNILCHATBOT_WEBHOOK = 'https://api.funilchatbot.com.br/wh/JvVtgM2KtxAVrgl-'

const PARA_QUEM = [
  {
    icon: 'trophy',
    title: 'Expert com 5+ anos',
    description: 'Você fatura bem no presencial, mas sabe que não vai escalar fazendo mais do mesmo. Precisa de estrutura digital.',
  },
  {
    icon: 'retry',
    title: 'Já tentou e não funcionou',
    description: 'Você investiu em curso, agência, lançamento. Gastou dinheiro e energia. Agora quer fazer do jeito certo, com método.',
  },
  {
    icon: 'layers',
    title: 'Quer criar uma esteira',
    description: 'Consultor ou mentor que precisa de produtos escaláveis: livro, curso, mentoria em grupo. Tudo conectado.',
  },
  {
    icon: 'book',
    title: 'Livro + Curso + Mentoria',
    description: 'Quer publicar seu livro, criar um curso e montar uma mentoria. Os três pilares de uma esteira completa.',
  },
]

const NAO_E_PARA = [
  'Quem busca fórmula mágica ou resultado sem esforço',
  'Quem não tem expertise real (menos de 3 anos de experiência)',
  'Quem não está disposto a investir tempo e dedicação',
]

const COMO_FUNCIONA = [
  { step: '01', title: 'Aplicação', description: 'Preencha o formulário de qualificação abaixo. Leva menos de 3 minutos.' },
  { step: '02', title: 'Conversa', description: 'Call de 30 minutos para alinhar expectativas e entender seu cenário.' },
  { step: '03', title: 'Aprovação', description: 'Avaliamos se é o momento certo para você. Nem todo mundo é aceito.' },
  { step: '04', title: 'Início', description: 'Onboarding completo com seu Mapa de Contexto no primeiro mês.' },
  { step: '05', title: 'Transformação', description: '6 meses construindo sua esteira completa, passo a passo.' },
]

const O_QUE_INCLUI = [
  { icon: 'passport', title: 'Mapa de Contexto completo', description: 'Diagnóstico profundo da sua expertise, mercado e posicionamento ideal.' },
  { icon: 'book', title: 'Livro produzido pela eBuz Editora', description: 'Da Etapa 1 ao livro publicado, com acompanhamento. Os arquivos são seus e saem prontos pra qualquer canal.' },
  { icon: 'stack', title: 'Esteira de produtos estruturada', description: 'Livro, curso, mentoria em grupo. Tudo conectado e com precificação.' },
  { icon: 'funnel', title: 'Funil de vendas perpétuo', description: 'Funil evergreen configurado para gerar vendas todos os dias.' },
  { icon: 'calendar', title: 'Acompanhamento semanal 1-a-1', description: 'Calls individuais toda semana. Sem grupo, sem gravação genérica.' },
  { icon: 'unlock', title: 'Acesso vitalício aos cursos', description: 'Todos os cursos da plataforma eBuz liberados para sempre.' },
]

const FAQ_ITEMS = [
  { question: 'Quanto custa a mentoria?', answer: 'O investimento depende do programa escolhido. Preencha o formulário de aplicação e conversamos sobre as opções que fazem sentido para o seu momento.' },
  { question: 'Quanto tempo dura?', answer: 'A mentoria individual dura 6 meses com calls semanais. A Etapa 1 do livro é um encontro de 2 horas com a editora. No livro, a meta é de 21 dias a partir da conversa de gravação, e depende das suas respostas.' },
  { question: 'Preciso ter um produto pronto?', answer: 'Não. A mentoria constrói tudo do zero, começando pelo Mapa de Contexto. Aliás, se você já tem um produto, vamos avaliar se ele está no caminho certo.' },
  { question: 'E se eu já tentei e não funcionou?', answer: 'Melhor ainda. Vamos entender por que falhou e corrigir com método. A maioria dos experts falha por falta de estrutura, não de competência.' },
  { question: 'Posso parcelar?', answer: 'Sim. Oferecemos opções de parcelamento em até 12x no cartão de crédito.' },
  { question: 'E se eu não gostar?', answer: 'Temos garantia nos primeiros 30 dias. Se você sentir que não é para você, devolvemos o investimento.' },
]

const FATURAMENTO_OPTIONS = [
  'Até R$ 10k/mês',
  'R$ 10k - R$ 30k/mês',
  'R$ 30k - R$ 80k/mês',
  'Acima de R$ 80k/mês',
]

// Prova contavel, nao depoimento. A casa tem ZERO casos de cliente com
// autorizacao escrita (brain, projects/evento-turma-fundadora-selo), entao
// nenhuma quote de cliente entra aqui ate haver papel assinado. O que entra e
// o que o visitante consegue conferir sozinho: a obra publicada, legivel na
// integra em biblioteca.ebuz.com.br.
const CASES = [
  {
    name: 'Dr. Ralph Rudolph',
    role: 'Médico do trabalho',
    obra: 'NR1 na Prática',
    fato: 'Obra completa publicada pela casa. Legível na íntegra na biblioteca, de graça, antes de você decidir qualquer coisa.',
  },
  {
    name: 'Dra. Maria Aparecida',
    role: 'Advogada de família',
    obra: 'Triagem Antes do Litígio',
    fato: 'Obra completa publicada pela casa, com página própria vendendo a versão física.',
  },
  {
    name: 'Pr. Fernando Costa',
    role: 'Capelania prisional',
    obra: 'CHAVE',
    fato: 'Obra completa publicada pela casa. Nenhum dos autores da prateleira vivia de escrever.',
  },
]

// Conferidos na fonte em 2026-09-04: catalog.json (22 obras de autor em 28
// titulos) e ebuz_prod (18 cursos published, 960 rows em course_lessons).
// O "900+ alunos" que estava aqui era inflado ~10x (o real e ~99 contas) e saiu.
const MENTOR_STATS = [
  { value: '22', label: 'obras de autor publicadas' },
  { value: '18', label: 'cursos no catálogo' },
  { value: '960', label: 'aulas publicadas' },
  { value: '12', label: 'pesquisadores na base' },
]

/* ====== Icons ====== */

function IconTrophy({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M18.75 4.236c.982.143 1.954.317 2.916.52A6.003 6.003 0 0016.27 9.728M18.75 4.236V4.5c0 2.108-.966 3.99-2.48 5.228m0 0a6.023 6.023 0 01-2.77.896m5.25-7.388V2.72" />
    </svg>
  )
}

function IconRetry({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182M21.015 4.356v4.992" />
    </svg>
  )
}

function IconLayers({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L12 12.75 6.429 9.75m11.142 0l4.179 2.25-9.75 5.25-9.75-5.25 4.179-2.25" />
    </svg>
  )
}

function IconBook({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
    </svg>
  )
}

function IconPassport({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
    </svg>
  )
}

function IconStack({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
    </svg>
  )
}

function IconFunnel({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z" />
    </svg>
  )
}

function IconCalendar({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
    </svg>
  )
}

function IconUnlock({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
    </svg>
  )
}

function IconCheck({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
    </svg>
  )
}

function IconX({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  )
}

function WhatsAppIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  )
}

const ICON_MAP: Record<string, React.FC<{ className?: string }>> = {
  trophy: IconTrophy,
  retry: IconRetry,
  layers: IconLayers,
  book: IconBook,
  passport: IconPassport,
  stack: IconStack,
  funnel: IconFunnel,
  calendar: IconCalendar,
  unlock: IconUnlock,
}

/* ====== FAQ Accordion ====== */

function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div className="space-y-3 max-w-3xl mx-auto">
      {FAQ_ITEMS.map((item, i) => (
        <div
          key={i}
          className="border border-slate-700/50 rounded-xl overflow-hidden bg-slate-800/50 backdrop-blur"
        >
          <button
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
            className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
          >
            <span className="text-base font-semibold text-white pr-4">{item.question}</span>
            <svg
              className={`w-5 h-5 text-teal-400 shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            className={`grid transition-all duration-300 ${openIndex === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
          >
            <div className="overflow-hidden">
              <p className="px-6 pb-5 text-sm text-slate-300 leading-relaxed">{item.answer}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

/* ====== Application Form ====== */

function ApplicationForm() {
  const [nome, setNome] = useState('')
  const [email, setEmail] = useState('')
  const [whatsapp, setWhatsapp] = useState('')
  const [nicho, setNicho] = useState('')
  const [faturamento, setFaturamento] = useState('')
  const [expectativa, setExpectativa] = useState('')
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!nome.trim() || !email.trim() || !whatsapp.trim()) return

    setSending(true)
    setError('')

    try {
      const phoneClean = whatsapp.replace(/\D/g, '')
      const mensagem = [
        `Nicho: ${nicho}`,
        `Faturamento: ${faturamento}`,
        `Expectativa: ${expectativa}`,
      ].join(' | ')

      const res = await fetch('/api/contato', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: nome.trim(),
          email: email.trim(),
          phone: phoneClean,
          ddi: '+55',
          message: `Aplicação Mentoria — ${mensagem}`,
          source: 'campanha',
        }),
      })

      if (!res.ok) throw new Error('Falha no envio')
      setSent(true)

      // Funil Chatbot webhook (fire-and-forget)
      fetch(FUNILCHATBOT_WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: nome.trim(),
          email: email.trim(),
          numero: phoneClean,
          assunto: 'Aplicação Mentoria',
          mensagem,
        }),
      }).catch(() => {})
    } catch {
      setError('Não foi possível enviar. Tente novamente ou entre em contato pelo WhatsApp.')
    } finally {
      setSending(false)
    }
  }

  if (sent) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 rounded-full bg-teal-500/20 flex items-center justify-center mx-auto mb-6">
          <IconCheck className="w-8 h-8 text-teal-400" />
        </div>
        <h3 className="text-2xl font-bold text-white mb-3">Aplicação enviada!</h3>
        <p className="text-slate-300 max-w-md mx-auto">
          Entraremos em contato em até 48 horas pelo WhatsApp. Fique de olho nas mensagens.
        </p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-2">Nome completo *</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
            className="w-full px-4 py-3 bg-slate-800/80 border border-slate-700 rounded-xl text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
            placeholder="Seu nome"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-2">E-mail *</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-3 bg-slate-800/80 border border-slate-700 rounded-xl text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
            placeholder="seu@email.com"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-2">WhatsApp *</label>
          <input
            type="tel"
            value={whatsapp}
            onChange={(e) => setWhatsapp(e.target.value)}
            required
            className="w-full px-4 py-3 bg-slate-800/80 border border-slate-700 rounded-xl text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
            placeholder="(61) 99999-9999"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-2">Nicho / Área de atuação</label>
          <input
            type="text"
            value={nicho}
            onChange={(e) => setNicho(e.target.value)}
            className="w-full px-4 py-3 bg-slate-800/80 border border-slate-700 rounded-xl text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
            placeholder="Ex: Educação, Saúde, Marketing..."
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-300 mb-2">Faturamento mensal atual</label>
        <select
          value={faturamento}
          onChange={(e) => setFaturamento(e.target.value)}
          className="w-full px-4 py-3 bg-slate-800/80 border border-slate-700 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition appearance-none"
        >
          <option value="">Selecione...</option>
          {FATURAMENTO_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-300 mb-2">O que espera da mentoria?</label>
        <textarea
          value={expectativa}
          onChange={(e) => setExpectativa(e.target.value)}
          rows={4}
          className="w-full px-4 py-3 bg-slate-800/80 border border-slate-700 rounded-xl text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition resize-none"
          placeholder="Conte um pouco sobre o que você busca e onde quer chegar..."
        />
      </div>

      {error && (
        <p className="text-red-400 text-sm">{error}</p>
      )}

      <button
        type="submit"
        disabled={sending}
        className="w-full py-4 bg-teal-500 hover:bg-teal-400 disabled:opacity-50 disabled:cursor-not-allowed text-slate-900 font-bold text-lg rounded-xl transition-all duration-200 cursor-pointer shadow-lg shadow-teal-500/25"
      >
        {sending ? 'Enviando...' : 'Enviar Aplicação'}
      </button>
    </form>
  )
}

/* ====== Main Page ====== */

export default function MentoriaPage() {
  function scrollToForm() {
    document.getElementById('aplicacao')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="min-h-screen bg-slate-950">
      {/* ========== HERO ========== */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0f172a] via-[#0f2d2a] to-[#134e4a]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(20,184,166,0.15),transparent_60%)]" />

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-20 sm:pt-28 pb-16 sm:pb-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal-500/10 border border-teal-500/20 mb-8">
                <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
                <span className="text-sm text-teal-300 font-medium">Vagas limitadas</span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.1] mb-6 tracking-tight">
                Construa sua esteira completa em{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-emerald-400">
                  6 meses
                </span>
              </h1>

              <p className="text-lg sm:text-xl text-slate-300 mb-10 leading-relaxed max-w-xl">
                Mentoria individual com Jonathan Machado. Do Mapa de Contexto ao faturamento recorrente com produtos educacionais.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={scrollToForm}
                  className="px-8 py-4 bg-teal-500 hover:bg-teal-400 text-slate-900 font-bold text-lg rounded-xl transition-all duration-200 cursor-pointer shadow-lg shadow-teal-500/25 hover:shadow-teal-400/30"
                >
                  Aplicar para o programa
                </button>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Tenho interesse na mentoria.')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 px-8 py-4 border border-slate-600 hover:border-slate-400 text-white font-semibold rounded-xl transition-all duration-200"
                >
                  <WhatsAppIcon className="w-5 h-5" />
                  Falar no WhatsApp
                </a>
              </div>
            </div>

            <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-br from-teal-500/20 to-emerald-500/20 rounded-3xl blur-2xl" />
                <Image
                  src="/images/jonathan-machado.jpg"
                  alt="Jonathan Machado - Mentor e CEO da eBuz"
                  width={480}
                  height={560}
                  className="relative rounded-2xl object-cover shadow-2xl w-72 sm:w-80 lg:w-[420px]"
                  priority
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== PARA QUEM E ========== */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4">Para quem é este programa</h2>
            <p className="text-lg text-slate-500 max-w-2xl mx-auto">
              A mentoria foi desenhada para profissionais que já têm expertise, mas precisam de estrutura para transformar conhecimento em receita previsível.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {PARA_QUEM.map((item, i) => {
              const Icon = ICON_MAP[item.icon]
              return (
                <div
                  key={i}
                  className="group p-8 rounded-2xl border border-slate-200 hover:border-teal-200 bg-white hover:bg-teal-50/50 transition-all duration-300 hover:shadow-lg"
                >
                  <div className="w-12 h-12 rounded-xl bg-teal-100 flex items-center justify-center mb-5 group-hover:bg-teal-200 transition-colors">
                    {Icon && <Icon className="w-6 h-6 text-teal-700" />}
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed">{item.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* ========== PARA QUEM NAO E ========== */}
      <section className="py-16 sm:py-20 bg-slate-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 text-center mb-10">Para quem NÃO é</h2>
          <div className="space-y-4">
            {NAO_E_PARA.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-4 p-5 rounded-xl bg-white border border-slate-200"
              >
                <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center shrink-0 mt-0.5">
                  <IconX className="w-4 h-4 text-red-500" />
                </div>
                <p className="text-base text-slate-700 leading-relaxed">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== COMO FUNCIONA ========== */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4">Como funciona</h2>
            <p className="text-lg text-slate-500">5 passos simples. Sem burocracia.</p>
          </div>

          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-6 sm:left-8 top-0 bottom-0 w-px bg-gradient-to-b from-teal-400 via-teal-300 to-transparent hidden sm:block" />

            <div className="space-y-8 sm:space-y-10">
              {COMO_FUNCIONA.map((item, i) => (
                <div key={i} className="flex gap-5 sm:gap-8 items-start">
                  <div className="relative z-10 w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-teal-500 to-emerald-600 flex items-center justify-center shrink-0 shadow-lg shadow-teal-500/20">
                    <span className="text-sm sm:text-base font-bold text-white">{item.step}</span>
                  </div>
                  <div className="pt-1 sm:pt-3">
                    <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-1">{item.title}</h3>
                    <p className="text-sm sm:text-base text-slate-500 leading-relaxed">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ========== O QUE INCLUI ========== */}
      <section className="py-20 sm:py-28 bg-gradient-to-br from-[#0f172a] to-[#134e4a]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">O que está incluído</h2>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto">
              Tudo que você precisa para sair do zero e montar uma esteira completa de produtos educacionais.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {O_QUE_INCLUI.map((item, i) => {
              const Icon = ICON_MAP[item.icon]
              return (
                <div
                  key={i}
                  className="p-7 rounded-2xl bg-white/5 border border-white/10 backdrop-blur hover:bg-white/10 transition-all duration-300"
                >
                  <div className="w-11 h-11 rounded-lg bg-teal-500/20 flex items-center justify-center mb-5">
                    {Icon && <Icon className="w-5 h-5 text-teal-400" />}
                  </div>
                  <h3 className="text-base font-bold text-white mb-2">{item.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{item.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* ========== PROGRAMAS DISPONIVEIS ========== */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4">Programas disponíveis</h2>
            <p className="text-lg text-slate-500 max-w-2xl mx-auto">
              Escolha o programa que faz sentido para o seu momento.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Card 1: Mentoria Individual (destaque) */}
            <div className="relative rounded-2xl bg-gradient-to-br from-[#0f172a] to-[#134e4a] p-8 lg:p-10 text-white shadow-2xl lg:scale-105 lg:-my-4 order-1">
              <div className="absolute top-5 right-5 px-3 py-1 bg-teal-500/20 border border-teal-500/30 rounded-full">
                <span className="text-xs font-semibold text-teal-300">Mais popular</span>
              </div>
              <h3 className="text-2xl font-extrabold mb-2">Mentoria Individual</h3>
              <p className="text-slate-300 mb-6">O programa completo</p>
              <ul className="space-y-3 mb-8">
                {[
                  '6 meses de acompanhamento',
                  'Calls semanais 1-a-1',
                  'Esteira completa + livro + funil',
                  'Acesso vitalício aos cursos',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-slate-200">
                    <IconCheck className="w-4 h-4 text-teal-400 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-sm text-teal-300 font-semibold mb-6">Investimento sob consulta</p>
              <button
                onClick={scrollToForm}
                className="w-full py-4 bg-teal-500 hover:bg-teal-400 text-slate-900 font-bold rounded-xl transition-all duration-200 cursor-pointer shadow-lg shadow-teal-500/25"
              >
                Aplicar agora
              </button>
            </div>

            {/* Card 2: Etapa 1 do livro (degrau 2 da escada; item tacito da tabela das propostas) */}
            <div className="rounded-2xl border border-slate-200 p-8 lg:p-10 bg-white hover:shadow-xl transition-all duration-300 order-2">
              <h3 className="text-2xl font-extrabold text-slate-900 mb-2">Etapa 1 do livro</h3>
              <p className="text-slate-500 mb-6">Degrau 2 da eBuz Editora</p>
              <ul className="space-y-3 mb-8">
                {[
                  'Encontro de 2 horas com a editora',
                  'Vira o esboço do livro, capítulo por capítulo',
                  'Se você não seguir, o valor volta inteiro',
                  'Se seguir, entra na conta do livro',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-slate-600">
                    <IconCheck className="w-4 h-4 text-teal-500 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mb-6">
                <span className="text-3xl font-extrabold text-slate-900">R$ 900</span>
                <span className="text-sm text-slate-400 ml-2">com devolução</span>
              </div>
              <Link
                href="/meu-livro"
                className="block w-full py-4 text-center border-2 border-teal-500 text-teal-600 hover:bg-teal-50 font-bold rounded-xl transition-all duration-200"
              >
                Começar pela Etapa 1
              </Link>
            </div>

            {/* Card 3: o livro pela tabela das propostas (degrau 3 da escada) */}
            <div className="rounded-2xl border border-slate-200 p-8 lg:p-10 bg-white hover:shadow-xl transition-all duration-300 order-3">
              <h3 className="text-2xl font-extrabold text-slate-900 mb-2">O livro, pela tabela</h3>
              <p className="text-slate-500 mb-6">Degrau 3: você fala, a casa escreve</p>
              <ul className="space-y-3 mb-8">
                {[
                  'Escrita a partir das suas falas, com a sua revisão',
                  'Capa, e-book e publicação',
                  'Você aprova cada etapa',
                  '100% dos direitos são seus',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-slate-600">
                    <IconCheck className="w-4 h-4 text-teal-500 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mb-6">
                <span className="text-3xl font-extrabold text-slate-900">R$ 13.847,90</span>
                <span className="text-sm text-slate-400 ml-2">11 itens base, preço de tabela</span>
              </div>
              <Link
                href="/editora/selo"
                className="block w-full py-4 text-center border-2 border-slate-300 text-slate-700 hover:border-slate-400 hover:bg-slate-50 font-bold rounded-xl transition-all duration-200"
              >
                Ver a tabela
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ========== RESULTADOS / CASES ========== */}
      <section className="py-20 sm:py-28 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4">A prova está na prateleira</h2>
            <p className="text-lg text-slate-500">
              Nenhum depoimento fabricado. 22 obras de autor publicadas pela casa, legíveis na íntegra em{' '}
              <a href="https://biblioteca.ebuz.com.br" target="_blank" rel="noopener noreferrer" className="text-teal-600 font-semibold hover:underline">biblioteca.ebuz.com.br</a>.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {CASES.map((c, i) => (
              <div
                key={i}
                className="relative p-8 rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <p className="text-xs font-bold uppercase tracking-widest text-teal-600 mb-2">Obra publicada</p>
                <p className="text-lg font-extrabold text-slate-900 mb-3">{c.obra}</p>
                <p className="text-base text-slate-600 leading-relaxed mb-6">{c.fato}</p>
                <div>
                  <p className="font-bold text-slate-900">{c.name}</p>
                  <p className="text-sm text-slate-400">{c.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== SOBRE O MENTOR ========== */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-br from-teal-500/10 to-emerald-500/10 rounded-3xl blur-xl" />
                <Image
                  src="/images/jonathan-machado.jpg"
                  alt="Jonathan Machado"
                  width={480}
                  height={600}
                  className="relative rounded-2xl object-cover shadow-xl w-72 sm:w-80 lg:w-[400px]"
                />
              </div>
            </div>

            <div>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-6">Sobre o Mentor</h2>
              <div className="space-y-4 text-base text-slate-600 leading-relaxed mb-8">
                <p>
                  <strong className="text-slate-900">Jonathan Machado</strong> é CEO da eBuz Negócios Digitais e criador da Metodologia APE (Arquitetura de Produtos Educacionais), que sintetiza o trabalho de 12 pesquisadores em mais de 6 décadas de pesquisa sobre aprendizagem e transferência de conhecimento.
                </p>
                <p>
                  Como ex-coprodutor digital, faturou R$ 700 mil em 6 meses antes de perceber que o modelo de lançamento era insustentável. Desenvolveu a APE como resposta a uma pergunta simples: como ajudar experts a construírem produtos educacionais que realmente funcionam?
                </p>
                <p>
                  Hoje, gerencia uma plataforma própria com 960 aulas distribuídas em 18 cursos, uma editora com 22 obras de autor publicadas, e construiu toda a infraestrutura tecnológica usando inteligência artificial como co-piloto.
                </p>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {MENTOR_STATS.map((stat, i) => (
                  <div key={i} className="text-center p-4 rounded-xl bg-slate-50">
                    <p className="text-2xl font-extrabold text-teal-600">{stat.value}</p>
                    <p className="text-xs text-slate-500 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== FAQ ========== */}
      <section className="py-20 sm:py-28 bg-gradient-to-br from-[#0f172a] to-[#1e293b]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">Perguntas frequentes</h2>
            <p className="text-lg text-slate-400">Tire suas dúvidas antes de aplicar.</p>
          </div>
          <FaqAccordion />
        </div>
      </section>

      {/* ========== FORMULARIO DE APLICACAO ========== */}
      <section id="aplicacao" className="py-20 sm:py-28 bg-gradient-to-br from-[#0f172a] via-[#0f2d2a] to-[#134e4a]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">Aplicar para o Programa</h2>
            <p className="text-lg text-slate-300 max-w-xl mx-auto">
              Preencha o formulário abaixo. Nossa equipe entrará em contato em até 48 horas.
            </p>
          </div>
          <ApplicationForm />
        </div>
      </section>

      {/* ========== CTA FINAL - gerenciado em /admin/ctas ========== */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <p className="text-center text-base text-slate-500 mb-4">Não está pronto para a mentoria?</p>
          <BlogCtaClient cta_key="passaporte" />
        </div>
      </section>

      {/* ========== FOOTER ========== */}
      <footer className="py-8 bg-slate-950 border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">&copy; {new Date().getFullYear()} eBuz Negócios Digitais. Todos os direitos reservados.</p>
          <div className="flex items-center gap-6">
            <Link href="/" className="text-sm text-slate-500 hover:text-slate-300 transition-colors">Início</Link>
            <Link href="/maquina-livros" className="text-sm text-slate-500 hover:text-slate-300 transition-colors">eBuz Editora</Link>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-slate-500 hover:text-slate-300 transition-colors"
            >
              Contato
            </a>
          </div>
        </div>
      </footer>

      {/* ========== WHATSAPP FLUTUANTE ========== */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Tenho interesse na mentoria.')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-400 rounded-full flex items-center justify-center shadow-xl shadow-green-500/30 transition-all duration-200 hover:scale-110"
        aria-label="Falar pelo WhatsApp"
      >
        <WhatsAppIcon className="w-7 h-7 text-white" />
      </a>
    </div>
  )
}
